import classNames from 'classnames';
import { DataGridDisplay, WeatherInfoDisplay } from 'components';
import WidgetLoadingAnimation from 'components/Widgets/WidgetLoadingAnimation';
import { WeatherContext } from 'pages/Forecast';
import React, { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import {
  WiDaySunny,
  WiMoonAltWaxingCrescent4,
  WiMoonrise,
  WiMoonset,
  WiSunrise,
  WiSunset,
} from 'react-icons/wi';
import 'styles/global.css';
import { GetWeatherTimeString } from 'utils/stringUtils';
import styles from './WeatherHome.module.css';

export default function WeatherHome() {
  const weatherContext = useContext(WeatherContext);
  const currentConditions = weatherContext?.currentConditions ?? [];
  const hourlyForecast = weatherContext?.hourly ?? [];
  const astronomy = weatherContext?.astronomy;

  if (weatherContext?.fetching) return <WidgetLoadingAnimation />;

  const currentCondition = currentConditions[0];

  return (
    <Container
      fluid
      className={classNames(styles.root, 'd-flex flex-column h-100 gap-4 user-select-none px-0')}
    >
      {/* Current Conditions / Sun & Moon Rise */}
      <Row className="g-4 align-items-stretch">
        {currentCondition && (
          <Col xs={12} lg={4} className="d-flex">
            <WeatherInfoDisplay
              data={currentCondition}
              title={`${new Date(currentCondition?.iso8601).toLocaleTimeString()} - ${new Date(
                currentCondition?.iso8601,
              ).toDateString()}`}
            />
          </Col>
        )}

        {astronomy?.sunrise && astronomy?.sunset && (
          <Col xs={12} lg={4} className="d-flex">
            <DataGridDisplay title="Sun" icon={<WiDaySunny size={25} />}>
              <div className={styles.iconContent}>
                <WiSunrise size={50} />
                <div>Sunrise: {astronomy.sunrise}</div>
              </div>
              <div className={styles.iconContent}>
                <WiSunset size={50} />
                <div>Sunset: {astronomy.sunset}</div>
              </div>
            </DataGridDisplay>
          </Col>
        )}

        {astronomy?.moonrise && astronomy?.moonset && (
          <Col xs={12} lg={4} className="d-flex overflow-hidden">
            <DataGridDisplay title="Moon" icon={<WiMoonAltWaxingCrescent4 size={25} />}>
              <div className={styles.iconContent}>
                <WiMoonrise size={50} />
                <div>Moonrise: {astronomy.moonrise}</div>
              </div>
              <div className={styles.iconContent}>
                <WiMoonset size={50} />
                <div>Moonset: {astronomy.moonset}</div>
              </div>
            </DataGridDisplay>
          </Col>
        )}
      </Row>

      {/* Short Hourly Forecast */}
      <div className={[styles.contentContainer, 'overflow-hidden']}>
        {hourlyForecast[0]?.iso8601 && (
          <div className={styles.title}>
            {`${new Date(hourlyForecast[0]?.iso8601).toDateString()} Hourly Forecast`}
          </div>
        )}

        <Row className="g-4">
          {hourlyForecast.map((item) => (
            <Col xs={12} md={6} key={item?.iso8601} className="d-flex overflow-none">
              <WeatherInfoDisplay
                data={item}
                title={GetWeatherTimeString(new Date(item?.iso8601))}
              />
            </Col>
          ))}
        </Row>
      </div>
    </Container>
  );
}
